"use strict";
import React from "react";
import { Link } from "react-router-dom";
import Moment from "moment-timezone";
import { getLogoutUrl } from './../../util/helpers';
import classNames from 'classnames';

class CurrentTime extends React.Component {
    getCurrentTimeString = () => {
        return Moment.utc().format('YYYY-MM-DD HH:mm:ss');
    };

    state = { currentTime: this.getCurrentTimeString() };

    componentDidMount() {
        this.intervalId = setInterval(() => {
            this.setState({ currentTime: this.getCurrentTimeString() });
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    render() {
        let localTime = Moment().format('dddd, MMMM Do YYYY, hh:mm:ss:SSS a ZZ');
        return (<div title={localTime}>{this.state.currentTime}&nbsp;</div>);
    }
}

const initComponent = (flex = window.flex) => {

    class OpsHeader extends React.PureComponent {
        componentDidMount() {
            if (screen.width <= 768) {
                $("body").addClass("mini-navbar").addClass("fixed-sidebar");
                this.setState({ hideSidebar: true });
            }
        }
        toggleSidebar = (event) => {
            event.stopPropagation();
            const state = this.state || {};
            const hideSidebar = state.hideSidebar || false;
            if(this.props.setIsShowOpsNav){
                this.props.setIsShowOpsNav();
            }
            this.setState({ hideSidebar: !hideSidebar });
        };

        render() {
            const state = this.state || {};
            const appContext = this.props.appContext;
            const session = this.props.session;
            const headerClassName = this.props.headerClassName;
            if (!session || !session.user) return false;
            const pageTitle = this.props.pageTitle || "Ops";
            const logoutUrl = getLogoutUrl(flex);
            const logoutLink = (<Link to={logoutUrl} className="logout-link">Logout</Link>);
            const hideSidebar = state.hideSidebar || false;
            if (hideSidebar) $("body").addClass("mini-navbar").addClass("fixed-sidebar");
            else $("body").removeClass("mini-navbar").removeClass("fixed-sidebar");

            const navItems = flex.getNavsByPosition(appContext, "Ops");
            const navLinks = navItems.map((navItem, index) => {
                return (
                    <li key={index}>
                        <Link to={navItem.link} title={flex.text(navItem.titleKey, navItem.title)}><i className="fa fa-diamond"></i> <span className="nav-label">{flex.text(navItem.labelKey, navItem.label)}</span></Link>
                    </li>
                )
            });
            return (
                <div>
                    <div className="row border-bottom">
                        <nav className="navbar navbar-static-top" role="navigation" style={{ marginBottom: "0" }}>
                            <div className="navbar-header">
                                <a className="navbar-minimalize minimalize-styl-2 btn btn-primary " ref={this.props.sideBarControl} onClick={this.toggleSidebar}><i className="fa fa-bars"></i> </a>


                            </div>
                            <ul className="nav navbar-top-links navbar-right">
                                <li><CurrentTime /></li>
                                <li>
                                    <Link to="/"><i style={{ fontSize: "34px", lineHeight: "14px", verticalAlign: "middle" }} className="fa fa-home"></i></Link>
                                </li>
                                <li>
                                    {session.user.summary}
                                </li>
                                <li>
                                    {logoutLink}
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className={classNames({'col-lg-9': !headerClassName}, headerClassName)}>
                            <h2>{pageTitle}</h2>

                        </div>
                    </div>
                </div>
            );
        }
    }

    return OpsHeader;
};

module.exports = initComponent;
